<template>
    <v-dialog v-model="calToggle" fullscreen hide-overlay scrollable transition="dialog-bottom-transition">
        <v-card tile>
            <v-toolbar flat dark color="primary">
                <v-btn icon dark @click="calToggle = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Quote </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text class="title font-weight-bold">{{ subTotal | currency }}</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
            <ValidationObserver ref="observer">
                <v-form ref="calform">
                    <v-list two-line subheader flat>
                        <v-subheader>Basic Options</v-subheader>
                        <v-list-item>
                            <v-list-item-content>
                                <ValidationProvider v-slot="{ errors }" name="Size" rules="required">
                                    <v-select
                                        v-model="form.size"
                                        :items="sizes"
                                        item-text="title"
                                        item-value="id"
                                        :error-messages="errors"
                                        label="Select a Size"
                                        data-vv-name="size"
                                        required
                                    ></v-select>
                                </ValidationProvider>
                                <ValidationProvider v-slot="{ errors }" name="County" rules="required">
                                    <v-select
                                        v-model="form.county"
                                        :items="counties"
                                        item-text="title"
                                        item-value="id"
                                        :error-messages="errors"
                                        label="Select a County"
                                        data-vv-name="county"
                                        required
                                    ></v-select>
                                </ValidationProvider>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                    <v-list two-line subheader flat>
                        <v-subheader class="pt-5">Options</v-subheader>
                        <v-list-item v-for="(option, index) in requiredOptions" :key="index">
                            <v-list-item-action>
                                <v-checkbox
                                v-model="requiredValue"
                                disabled
                                ></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ option.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ option.price | currency }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item v-for="(option, index) in filteredOptions" :key="index">
                            <v-list-item-action>
                                <v-checkbox v-model="form.pooloptions" :value="option.id"></v-checkbox>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>{{ option.title }}</v-list-item-title>
                                <v-list-item-subtitle>{{ option.price | currency }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-form>
            </ValidationObserver>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click.prevent="calToggle = false">Close</v-btn>
                <v-btn color="red darken-1" text @click="reset">Reset</v-btn>
            </v-card-actions>      
        </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    data () {
        return {
            requiredValue: true,
            form: {
                size: null,
                county: null,
                pooloptions: []
            },
        }
    },
    computed: {
        ...mapGetters({
            dialog: 'menu/calculatorDialog',
            counties: 'data/counties',
            sizes: 'data/sizes',
            filteredOptions: 'data/filteredOptions',
            requiredTotal: 'data/requiredTotal',
            requiredOptions: 'data/requiredOptions',
        }),
        calToggle: {
            get() {
                return this.dialog
            },
            set(newValue) {
                this.$store.commit('menu/SET_CAL_DIALOG', newValue)
            }
        },
        sizePrice() {
            let sizePrice = 0

            if(this.form.size !== null) {
                let sizeArr = this.sizes.filter(size => {
                    return size.id == this.form.size
                })

                sizePrice += parseFloat(sizeArr[0].price) + this.requiredTotal
            }

            return sizePrice 
        },
        countyPrice() {
            let countyPrice = 0

            if(this.form.county !== null) {
                let countyArr = this.counties.filter(county => {
                    return county.id == this.form.county
                })

                countyPrice += parseFloat(countyArr[0].price)
            }

            return countyPrice
        },
        optionsTotal() {
            let optionsTotal = 0
            this.form.pooloptions.forEach(option => {
                let optionArr = this.filteredOptions.filter(fo => {
                    return fo.id == option
                })
                
                optionsTotal += parseFloat(optionArr[0].price)
                
            })
            return optionsTotal
        },
        subTotal() {
            return this.sizePrice + this.countyPrice + this.optionsTotal
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        reset () {
            this.form.county = null
            this.form.size = null
            this.form.pooloptions = []
        },
    }
}
</script>